import {createContext} from 'react';
import axios from '../../../../../../api/axios'

export const store = createContext(null);
export const initialState = {
    progress:false,
    fleetOptions:null,
    interests:null,
    files:null
}
export const reducer = (state,actions)=>{
    const {type,payload} = actions;
    switch (type) {
        case 'PROGRESS':
            return {...state,progress:payload}
        case 'SELECT_FLEETOPTIONS':
            return {...state,fleetOptions:payload}
        case 'SELECT_INTERESTS':
            return {...state,interests:payload}
        case 'SELECT_FILES':
            return {...state,files:payload}
    }
}
export const actions = {
    startImporting:async ({interests,file,fleetOptions})=>{
        try {
            var _data = new FormData();
            _data.set('interests',interests[0]);
            _data.set('fleetOptions',fleetOptions[0]);
            _data.set('file',file);
            const {data} = await axios.post(`/api/v1/admin/users/import/drivers`,_data,{
                headers: { "Content-Type": "multipart/form-data" },
              })
            return data;
        } catch (error) {
            throw error;
        }
    }
}